import script from "./AppButtonIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButtonIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppButtonIcon.vue?vue&type=style&index=0&id=4c8918c0&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8918c0"]])

export default __exports__